// Copyright (c) 2016 Deere & Company

import DateCellRenderer from '../../shared/report-cell-renderers/date-cell-renderer';
import PinCellRenderer from '../../shared/report-cell-renderers/pin-cell-renderer';
import classNames from '../../shared/constants/ag-grid-class-names';
import dateFilterParams from '../../shared/constants/date-filter-params';
import {translate} from '../../../shared/services/translation-service';

export function getSettlementNoRegistrationColumnDefinitions() {

    return [
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: PinCellRenderer,
            colId: 'pin',
            field: 'pin',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PIN'),
            width: 190
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'responsibleDealer',
            field: 'responsibleDealer',
            headerClass: classNames.headerClassName,
            headerName: translate('CURRENT_ACCOUNT'),
            width: 170
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'branch',
            field: 'branch',
            headerClass: classNames.headerClassName,
            headerName: translate('BRANCH'),
            width: 100
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'division',
            field: 'division',
            headerClass: classNames.headerClassName,
            headerName: translate('DIVISION'),
            width: 100
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'invoiceDealer',
            field: 'invoiceDealer',
            headerClass: classNames.headerClassName,
            headerName: translate('INVOICE_ACCOUNT'),
            width: 170
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'settlementDate',
            field: 'settlementDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('SETTLED'),
            width: 120
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'invoiceNumber',
            field: 'invoiceNumber',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('INVOICE_NUMBER'),
            width: 160
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'invoiceDate',
            field: 'invoiceDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('INVOICED'),
            width: 120
        }
    ];

}



// WEBPACK FOOTER //
// ./src/reports/settlement-no-registration/report-services/column-definitions.js